import { CommonModule } from '@angular/common';
import {
    Component,
    Input,
    OnDestroy,
    ChangeDetectionStrategy,
} from '@angular/core';

@Component({
    selector: 'app-loading-dots',
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './loading-dots.component.html',
})
export class LoadingDotsComponent implements OnDestroy {
    /**
     * Total number of dots to display.
     */
    @Input() count = 11;

    /**
     * How many dark dots move together.
     */
    @Input() active = 3;

    /**
     * How fast the 'train' moves.
     */
    @Input() stepMs = 180;

    /**
     * Tailwind size utilities.
     */
    @Input() sizeClass = 'w-3 h-3';

    /**
     * Spacing between dots.
     */
    @Input() gapClass = 'gap-2';

    /**
     * Dark dot color.
     */
    @Input() darkClass = 'bg-primary-600';

    /**
     * Light dot color.
     */
    @Input() lightClass = 'bg-primary-50';

    dots: number[] = Array.from({ length: this.count }, (_, i) => i);
    head = 0;

    private timerId: number = window.setInterval(
        () => {
            this.head = (this.head + 1) % this.count;
        },
        Math.max(60, this.stepMs),
    );

    ngOnDestroy(): void {
        clearInterval(this.timerId);
    }

    isActive(i: number): boolean {
        return (i - this.head + this.count) % this.count < this.active;
    }
}
